new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        heightContainerPhoto() {
            const productDetailHeader = document.querySelector('.product-detail__header');
            const photoImg = document.querySelector('.product-detail__header--photoArea-photo-thumb img');
            if (productDetailHeader && photoImg) {
                let heightPhoto = photoImg.getBoundingClientRect().height;
                productDetailHeader.style.maxHeight = heightPhoto + 'px';
            }
        },
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
                .then(res => {
                    const actualElement = event.target;
                    if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                        $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                    }
                    actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                    actualElement.closest('.product-item-kit').querySelector('.is-selected').classList.remove('is-selected');
                    actualElement.closest('.product__colors-item').classList.add('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                    actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                    const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                    actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                    var sizes = [];
                    for (i = 0; i <= res.data.variations.length - 1; i++) {
                        if (res.data.variations[i].main_attribute != null) {
                            sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                        }
                    }
                    for (i = 0; i <= sizes.length - 1; i++) {
                        if (sizes[i].main_attribute != null) {
                            var randomNumber = Math.floor(Math.random() * 99999999);
                            var stock = sizes[i].available == false ? 'out-of-stock' : '';
                            actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail_{{ auto_id|unlocalize }}_${res.data.id}_${randomNumber}" id="product_item_variation__product_detail_{{ auto_id|unlocalize }}_${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="{{ auto_id|unlocalize }}" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail_{{ auto_id|unlocalize }}_${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                        }
                    }
                    if (res.data.addons.length) {
                        var complements = document.createElement('div');
                        complements.setAttribute('id', 'js-product_addons__product_detail_{{ auto_id|unlocalize }}');
                        complements.setAttribute('class', 'complements');
                        complements.setAttribute('complements-for', '{{ p.id }}');
                        complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                        for (i = 0; i <= res.data.addons.length - 1; i++) {
                            var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                            var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                            complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                            if (res.data.addons[i].field_type == "radio_options") {
                                var complementsSelect = document.createElement('select');
                                complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                                complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                                for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                    complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                                }
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content');
                                $(selectDiv).append(complementsSelect);
                                $(complements).append(selectDiv);
                            } else if (res.data.addons[i].field_type == "text") {
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content-area');
                                $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                                $(complements).append(selectDiv);
                            }
                        }
                        $('.kitcolors').closest('.itens-for-carousel').append(complements);
                    }
                    $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function () {
                        $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);
                    });
                    if (window.outerWidth <= 991) {
                        var slickSlider = $('.product-detail__header--photoArea-mobile');

                        if (slickSlider.hasClass('slick-initialized')) {
                            slickSlider.slick('slickRemove', null, null, true);
                        } else {
                            slickSlider.slick();
                        }

                        for (i = 0; i < res.data.images.length; i++) {
                            slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                        }

                        slickSlider.slick('slickGoTo', 1);
                    } else {
                        const noThumbs = document.querySelector('#product-photo');
                        if (noThumbs) {
                            var noThumbsUl = document.querySelector('#product-photo ul');

                            // Remova todos os spans dentro do noThumbsUl
                            while (noThumbsUl.firstChild) {
                                noThumbsUl.removeChild(noThumbsUl.firstChild);
                            }

                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                var li = document.createElement('li');
                                li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                                noThumbsUl.appendChild(li);
                            }
                        } else {
                            $('.sp-wrap').each(function () {
                                $(this).closest('.slick-slide').remove();
                            });
                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                                if (i == 0) {
                                    document.querySelector('.sp-wrap').click();
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img');

                if (photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        singlePhotoItem.forEach((content) => {
                            content.classList.remove('active');
                        });
                        singlePhotoItem[index].classList.add('active');
                    }

                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                            activeTab(index);
                        });
                    });
                }
            }

            if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                $('#photo-list').slick({
                    infinite: false,
                    slidesToShow: 5,
                    vertical: true,
                    slidesToScroll: 1
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();

        var inputImage = document.querySelectorAll('.inputfile');
        if (inputImage) {
            Array.from(inputImage).forEach((item) => {
                item.addEventListener("change", function (e) {
                    var label = item.nextElementSibling,
                        spanLabel = label.querySelector('span'),
                        filename = this.value.replace(/.*[\/\\]/, ''),
                        file = item.files[0],
                        reader = new FileReader();
                    spanLabel.innerHTML = filename
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        $(item).attr("base64", reader.result)
                    };
                    reader.onerror = function (error) {
                        console.log('Error: ', error);
                    };
                })
            })
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });

        const moveComplements = () => {
            const kit = document.querySelector('.product-detail__header--infoArea-kit');
            if (!kit) return;

            const toMove = Array.from(
                document.querySelectorAll('.product-detail__header--infoArea-variation .complements')
            ).filter(el => !kit.contains(el));

            if (!toMove.length) return;

            let wrapper = kit.querySelector(':scope > .product-detail__header--infoArea-variation');
            if (!wrapper) {
                wrapper = document.createElement('div');
                wrapper.className = 'product-detail__header--infoArea-variation';
                const colorsDiv = document.createElement('div');
                colorsDiv.className = 'product-colors';
                wrapper.appendChild(colorsDiv);
                kit.appendChild(wrapper);
            }

            const colorsDiv = wrapper.querySelector('.product-colors');
            toMove.forEach(el => colorsDiv.appendChild(el));
        };

        moveComplements();

        const variationArea = document.querySelector('.product-detail__header--infoArea-variation');
        if (variationArea) {
            new MutationObserver(moveComplements).observe(variationArea, { childList: true, subtree: true });
        }
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            height: "auto",
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                    if (actual === end) {
                        addToCartButton.classList.remove('no-buy');
                        nextButton.classList.add('no-click');
                    }
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                if (actual === end) {
                    nextButton.classList.remove('no-click');
                }
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }


    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('#product-detail-related-carrousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    arrows: true,
                }
            },
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();
})